<template>
    <div class="md:flex-row flex flex-col">
        <aside class="md:w-220px w-full">
            <h5 class="mt-0">{{ $t('globals.sections') }}</h5>
            <div class="list-group">
                <a class="list-group-item px-2 py-2" :class="{ active : (hash === 'invoices' || hash === '') }" href="javascript:;" @click="setHash('invoices')">
                    <span class="icon icon-file-pdf-o icon-lg icon-fw"></span>
                    {{ $t('globals.invoices') }}
                </a>
                <a class="list-group-item px-2 py-2" :class="{ active : hash === 'billing-settings' }" href="javascript:;" @click="setHash('billing-settings')">
                    <span class="icon icon-cog icon-lg icon-fw"></span>
                    {{ $t('organization_payments.billing_settings') }}
                </a>
                <a class="list-group-item px-2 py-2" :class="{ active : hash === 'subscriptions' }" href="javascript:;" @click="setHash('subscriptions')">
                    <span class="icon icon-ticket icon-lg icon-fw"></span>
                    {{ $t('organization_payments.subscriptions') }}
                </a>
            </div>
        </aside>
        <div class="md:pl-15px flex-1">
            <div v-if="hash === 'invoices' || hash === ''">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('globals.invoices') }}</h4>
                    <p class="mb-0">{{ $t('organization_payments.invoices_info') }}</p>
                </div>
                <div>
                    <invoices-tab
                        :next-invoice="nextInvoice"
                        :issued-invoices="issuedInvoices"
                        :invoice-statuses="invoiceStatuses">
                    </invoices-tab>
                </div>
            </div>
            <div v-else-if="hash === 'billing-settings'">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('organization_payments.billing_settings') }}</h4>
                    <p class="mb-0">{{ $t('organization_payments.billing_settings_info') }}</p>
                </div>
                <div>
                    <billing-settings-tab
                        :countries="countries"
                        :payment-processor="paymentProcessor"
                        :payu-payment-info-form-data="payuPaymentInfoFormData"
                        :pending-card-details="pendingCardDetails"
                        :is-paying-by-bank-transfer="isPayingByBankTransfer">
                    </billing-settings-tab>
                </div>
            </div>
            <div v-else-if="hash === 'subscriptions'">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('organization_payments.subscriptions') }}</h4>
                    <p class="mb-0">{{ $t('organization_payments.subscriptions_info') }}</p>
                </div>
                <div>
                    <subscriptions-tab
                        :applications="activeApplications">
                    </subscriptions-tab>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BillingSettingsTab from './partials/billing-settings-tab.vue';
import InvoicesTab from './partials/invoices-tab.vue';
import SubscriptionsTab from './partials/subscriptions-tab.vue';

export default {
    components: {
        'billing-settings-tab': BillingSettingsTab,
        'invoices-tab': InvoicesTab,
        'subscriptions-tab': SubscriptionsTab,
    },

    props: {
        applications: {
            type: Array,
            required: true,
        },
        nextInvoice: {
            type: Object,
            required: true,
        },
        initialIssuedInvoices: {
            type: Array,
            required: true,
        },
        invoiceStatuses: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
        paymentProcessor: {
            type: String,
            required: true,
        },
        payuPaymentInfoFormData: {
            required: true,
        },
        pendingCardDetails: {
            type: Boolean,
            required: true,
        },
        isPayingByBankTransfer: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            hash: window.location.hash.substr(1),
            issuedInvoices: [...this.initialIssuedInvoices],
        };
    },

    computed: {
        activeApplications() {
            return this.applications.filter(application => application.status === 'active');
        },
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substr(1);
            this.broadcastHashChange(hash);
        });

        Bus.$on('shouldUpdateIssuedInvoice', ({ id, status, fiscalInvoiceId }) => this.updateIssuedInvoice(id, status, fiscalInvoiceId));
    },

    methods: {
        updateIssuedInvoice(id, status, fiscalInvoiceId) {
            const invoiceKey = this.issuedInvoices.findIndex(issuedInvoice => issuedInvoice.id === id);
            if (status === 'converted_to_fiscal') {
                axios.get(`/api/v1/invoices/${fiscalInvoiceId}`)
                    .then(response => {
                        const invoiceIdentificator = this.issuedInvoices[invoiceKey].identificator;
                        this.issuedInvoices = this.issuedInvoices.filter(issuedInvoice => issuedInvoice.id !== id);
                        this.issuedInvoices.unshift(response.data);

                        const message = this.$t('organization_payments.invoice_paid', {
                            emphasizedOpen: '<span class="font-semibold">',
                            emphasizedClose: '</span>',
                            lineBreak: '<br/>',
                            invoiceIdentificator: invoiceIdentificator,
                            fiscalInvoiceIdentificator: response.data.identificator,
                        });
                        window.toastr.clear();
                        window.toastr.success(message, null, { timeOut: 0, extendedTimeOut: 0 });
                    })
                    .catch(() => {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    });
            } else {
                this.issuedInvoices[invoiceKey].status = status;
            }
        },

        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },
    },
};
</script>
